import services from '../../../services'

const state = {
}

const actions = {
    async batchSaveFeatures({ commit }, body) {
        return await services.features_batchSave(body)
    },
    async batchEditFeatures({ commit }, body) {
        return await services.features_batchEdit(body)
    },
    async findFeatureByRegionId({ commit }, body) {
        return await services.features_findByRegionId(body)
    },
    async featurePublish({commit}, body){
        return await services.features_publish(body)
    },
    async featuresRestore({commit}, body){
        return await services.features_restore(body)
    },
    async getRefreshViewFeatureMath({commit}, body){
        return await services.features_getRefreshViewChangeMath(body)
    },
    async getFeaturePublishInfo({commit}, body){
        return await services.features_getPublishInfo(body)
    } , 
    async getPublishFeaturesByRegion({commit}, body){
        return await services.features_getPublishFeaturesByRegion(body)
    },
    async getPublishFeaturesByRegions({commit}, body){
        return await services.features_getPublishFeaturesByRegions(body)
    },
    async getPublishFeatureById({commit}, body){
        return await services.features_getPublishFeatureById(body)
    }
}

const mutations = {
}
export default {
    state,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/system/features.js